import { Popover, PopoverContent, PopoverTrigger } from '@/components/ui/popover';
import { Button } from '@/components/ui/button';
import { t } from 'i18next';
import { Icon, Typography } from '@/components';
import { Separator } from '@radix-ui/react-dropdown-menu';
import { useState } from 'react';

export function SortableHeader({ column }: any) {
  const sortDirection = column.getIsSorted();
  const [open, setOpen] = useState(false);

  return (
    <div className="flex items-center gap-2">
      <Popover open={open} onOpenChange={setOpen}>
        <PopoverTrigger asChild>
          <Button variant="ghost" size="sm" className="h-6 w-22 cursor-pointer p-0 hover:bg-transparent">
            <Typography as="h6" size="body-2" weight="semibold" className="text-neutral-500">
              {t('Capacity')}
            </Typography>
            {sortDirection === 'asc' ? (
              <Icon name="arrow-up" className="h-6 w-6 text-neutral-500" />
            ) : sortDirection === 'desc' ? (
              <Icon name="arrow-down" className="h-6 w-6 text-neutral-500" />
            ) : (
              <Icon name="chevrons-up-down" className="h-6 w-6 text-neutral-500" />
            )}
          </Button>
        </PopoverTrigger>
        <PopoverContent className="mt-3 w-40 p-1" align="start">
          <div className="flex flex-col gap-1">
            <Button
              variant="ghost"
              size="sm"
              className="cursor-pointer justify-start gap-2"
              onClick={() => {
                column.toggleSorting(false);
                setOpen(false);
              }}
            >
              <Icon name="arrow-up" className="h-6 w-6" />
              {t('Ascending')}
            </Button>
            <Button
              variant="ghost"
              size="sm"
              className="cursor-pointer justify-start gap-2"
              onClick={() => {
                column.toggleSorting(true);
                setOpen(false);
              }}
            >
              <Icon name="arrow-down" className="h-6 w-6" />
              {t('Descending')}
            </Button>
            <Separator className="border-t border-gray-300" />
            <Button
              variant="ghost"
              size="sm"
              className="cursor-pointer justify-start gap-2"
              onClick={() => {
                column.clearSorting();
                setOpen(false);
              }}
            >
              <Icon name="x" className="h-6 w-6" />
              {t('Clear')}
            </Button>
          </div>
        </PopoverContent>
      </Popover>
    </div>
  );
}
